import api from './api';
const BASE = '/microcredit-transactions';

export default {
  listByAccount: (microCreditId, params = {}) =>
    api.get(`${BASE}/${microCreditId}`, {
      params: { functionCode: 'MICRO_CREDIT_VIEW', ...params },
    }).then((r) => r.data),

  disburse: (microCreditId, data = {}) =>
    api.post(`${BASE}/${microCreditId}/disburse`, { ...data, functionCode: 'MICRO_CREDIT_DISBURSE' }).then((r) => r.data),

  payment: (microCreditId, data = {}) =>
    api.post(`${BASE}/${microCreditId}/payment`, { ...data, functionCode: 'MICRO_CREDIT_PAYMENT' }).then((r) => r.data),
};
